import { render, staticRenderFns } from "./ProviderSelector.vue?vue&type=template&id=505028aa&scoped=true&"
import script from "./ProviderSelector.vue?vue&type=script&lang=js&"
export * from "./ProviderSelector.vue?vue&type=script&lang=js&"
import style0 from "./ProviderSelector.vue?vue&type=style&index=0&id=505028aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505028aa",
  null
  
)

export default component.exports